import { render, staticRenderFns } from "./Colunas.vue?vue&type=template&id=659605da&scoped=true&lang=pug"
import script from "./Colunas.vue?vue&type=script&lang=js"
export * from "./Colunas.vue?vue&type=script&lang=js"
import style0 from "./Colunas.styl?vue&type=style&index=0&id=659605da&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659605da",
  null
  
)

export default component.exports